import { styled } from '@mui/material';

export const StyledNotificationItemPlug = styled('div')(({ theme }) => ({
	position: 'absolute',
	top: '-23px',
	left: '-2px',
	background: theme.palette.error.contrastText,
	color: theme.palette.common.white,
	padding: '0px 8px 15px 8px',
	borderRadius: '8px',
	fontSize: '12px',
	fontWeight: 600,
	clipPath: 'polygon(50% 0%, 100% 0, 150% 55%, 27% 56%, 11px 55%, 3px 68%, 0 85%, 0 54%, 0 0)',
	'&::after': {
		content: "''",
		position: 'absolute',
		width: '20px',
		height: '16px',
		top: '6px',
		left: 'calc(100% - 2px)',
		background: `radial-gradient(circle at top left, transparent 67%, ${theme.palette.error.contrastText} 68%)`,
		transform: 'rotate(90deg)',
	},
}));
